module.exports = function getResource(label, vars = []) {
    const resources = {
        reset: 'Reset',
        filter: 'filter'
    };
    return resources[label];
};
